import firebase from "firebase";

// Must match the edition of the `inscriptions<year>` Firestore collection,
// otherwise uploads and downloads point at different storage folders.
const INSCRIPTIONS_FOLDER = "2026";

export function inscriptionCVPath(inscriptionId) {
  return INSCRIPTIONS_FOLDER + "/" + inscriptionId + "_CV.pdf";
}

export function inscriptionLetterPath(inscriptionId) {
  return INSCRIPTIONS_FOLDER + "/" + inscriptionId + "_letter.pdf";
}

export async function uploadFile(fileObject, fullName) {
  var storageRef = firebase.storage().ref();
  var fileRef = storageRef.child(fullName)
  const fileRefPutResponse = await fileRef.put(fileObject)
 // console.log('fileRefPutResponse', fileRefPutResponse);
  return fileRefPutResponse
}

export async function removeFile(name) {
  if (!name) return
  const storage = firebase.storage().getStorage()
  const fileRef = firebase.storage().ref(storage, name)
  return await firebase.storage().deleteObject(fileRef)
}

export async function getDownloadURL(filePath) {

  console.log(1);
  //const fileRef = firebase.storage().ref(filePath)
  //console.log('fileRef', fileRef);
  var downloadURL = await firebase.storage().ref(filePath).getDownloadURL()
  //console.log('downloadURL', downloadURL);
  return downloadURL
}
